import { useEffect, useState } from "react";
import { fmtDateTime } from "@/components/DatePicker";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RoleBadge } from "@/components/RoleBadge";
import { Eye, EyeOff, RefreshCw } from "lucide-react";

const fmt = (iso) => (iso ? fmtDateTime(iso) : "—");
const dur = (a, b) => { if (!a || !b) return ""; const m = Math.max(1, Math.round((new Date(b) - new Date(a)) / 60000)); return m < 60 ? `${m} min` : `${Math.floor(m / 60)}h ${m % 60}m`; };

export function ImpersonationLog() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/users/impersonation-log").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (!rows) return null;
  return (
    <Card className="p-5 space-y-4" data-testid="impersonation-log">
      <div className="flex items-start justify-between gap-3">
        <div><h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><Eye className="w-5 h-5 text-primary" /> Impersonation log</h2><p className="text-xs text-muted-foreground mt-0.5">Every time an admin viewed the app as a client, employee or user — who, whom, and when.</p></div>
        <Button size="sm" variant="ghost" data-testid="impersonation-log-refresh" onClick={load}><RefreshCw className="w-4 h-4" /></Button>
      </div>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground py-4 text-center" data-testid="impersonation-log-empty">No impersonation sessions yet.</p> : (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-muted-foreground"><th className="pb-2 pr-3 font-medium">When</th><th className="pb-2 pr-3 font-medium">Admin</th><th className="pb-2 pr-3 font-medium">Event</th><th className="pb-2 pr-3 font-medium">Viewed as</th><th className="pb-2 font-medium">Role</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} className="border-t border-border" data-testid={`impersonation-row-${r.id}`}>
              <td className="py-2 pr-3 whitespace-nowrap font-mono-num text-xs">{fmt(r.created_at)}</td>
              <td className="py-2 pr-3">{r.actor_name || r.actor_id}</td>
              <td className="py-2 pr-3">{r.action === "impersonate" ? <span className="inline-flex items-center gap-1 text-amber-700"><Eye className="w-3.5 h-3.5" /> Started</span> : <span className="inline-flex items-center gap-1 text-muted-foreground"><EyeOff className="w-3.5 h-3.5" /> Stopped{r.started_at ? ` · ${dur(r.started_at, r.created_at)}` : ""}</span>}</td>
              <td className="py-2 pr-3 font-medium">{r.label || "—"}</td>
              <td className="py-2">{r.role ? <RoleBadge role={r.role} /> : "—"}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </Card>
  );
}
